import { Chess } from 'chess.js';
import { GameLogic } from './GameLogic';
import chessAudio from '../utils/chessAudio';

/**
 * Computer Player Service
 * Single Responsibility: Automated computer move execution
 * Open/Closed: Can be extended with different AI strategies
 */
export class ComputerPlayer {
  constructor(gameState, uiState) {
    this.gameState = gameState;
    this.uiState = uiState;
    this.moveDelay = 450; // ms, reply quickly so the line keeps flowing
    this.pendingMoves = new Set();
  }

  // Cancels scheduled moves, e.g. when switching to another line
  cancel() {
    this.pendingMoves.forEach(timeout => clearTimeout(timeout));
    this.pendingMoves.clear();
  }

  autoPlayMoves(currentGame, startMoveIndex = 0) {
    const { currentLine } = this.gameState;
    
    if (!currentLine || startMoveIndex >= currentLine.moves.length) {
      return;
    }

    this._scheduleNextMove(currentGame, startMoveIndex);
  }

  _scheduleNextMove(currentGame, moveIndex) {
    const { currentLine } = this.gameState;
    
    // Check if this move should be played by computer
    if (currentLine.playerMoves.includes(moveIndex)) {
      return; // Player's turn
    }

    const timeout = setTimeout(() => {
      this.pendingMoves.delete(timeout);
      this._executeMove(currentGame, moveIndex);
    }, this.moveDelay);
    this.pendingMoves.add(timeout);
  }

  _executeMove(currentGame, moveIndex) {
    const { currentLine, setGame, setMoveIndex } = this.gameState;
    const { clearGameState, setLastMove } = this.uiState;
    
    if (moveIndex >= currentLine.moves.length) {
      return;
    }

    const gameCopy = new Chess(currentGame.fen());
    
    try {
      const computerMove = gameCopy.move(currentLine.moves[moveIndex]);
      
      // Play appropriate sound
      this._playMoveSound(computerMove);
      
      // Update game state
      setGame(gameCopy);
      setMoveIndex(moveIndex + 1);
      // setFeedback(`Computer played: ${currentLine.moves[moveIndex]}`);
      
      // Clear UI state and highlight the reply
      clearGameState();
      setLastMove({ from: computerMove.from, to: computerMove.to });
      
      // Schedule next move if it's also computer's turn
      this._scheduleNextMove(gameCopy, moveIndex + 1);
      
    } catch (error) {
      console.error(`Failed computer move ${moveIndex}:`, error);
    }
  }

  _playMoveSound(move) {
    const moveType = GameLogic.getMoveType(move);
    
    switch (moveType) {
      case 'castle':
        chessAudio.playCastleSound();
        break;
      case 'check':
        chessAudio.playCheckSound();
        break;
      case 'capture':
        chessAudio.playCaptureSound();
        break;
      default:
        chessAudio.playMoveSound();
    }
  }

  setMoveDelay(delay) {
    this.moveDelay = delay;
  }
}